import { Injectable } from '@angular/core';
import { AccountManager } from '../model/accountManager';
import { MigrateEnvironment } from '../model/place';


const SIDE_BAR_STATUS = "SIDE_BAR_STATUS"
const STAFF_KEY = "STAFF"
const MIGRATE_ENVIRONMENT = "MIGRATE_ENVIRONMENT"
export const AUTH_ACCESS_TOKEN_KEY = "AUTH_ACCESS_TOKEN"
export const AUTH_REFRESH_TOKEN_KEY = "AUTH_REFRESH_TOKEN"


@Injectable({
  providedIn: 'root'
})
export class StorageService {
  constructor() { }

  saveSideBarStatus(status: boolean): void {
    localStorage.setItem(SIDE_BAR_STATUS, status.toString())
  }

  getSideBarStatus(): boolean {
    return localStorage.getItem(SIDE_BAR_STATUS) === "true"
  }

  saveSelectedTabIndex(index: number): void {
    sessionStorage.setItem("SELECTED_TAB_INDEX", index.toString())
  }

  getSelectedTabIndex(): number {
    return Number(sessionStorage.getItem("SELECTED_TAB_INDEX"))
  }

  getUser(): AccountManager | null {
    const user = localStorage.getItem(STAFF_KEY);
    if (user) {
      return JSON.parse(user);
    }
    return null;
  }

  saveUser(staff: AccountManager): void {
    localStorage.setItem(STAFF_KEY, JSON.stringify(staff))
  }

  saveMigrateEnvironment(env: MigrateEnvironment): void {
    localStorage.setItem(MIGRATE_ENVIRONMENT, JSON.stringify(env))
  }

  getMigrateEnvironment(): MigrateEnvironment {
    const env = localStorage.getItem(MIGRATE_ENVIRONMENT);
    if (env) {
      return JSON.parse(env);
    }
    return MigrateEnvironment.DEV;
  }

  clean(): void {
    localStorage.clear();
  }
}
